(() => {
  const body = document.body;
  let returnFocus = null;

  const openDialog = (dialog, trigger) => {
    if (!dialog) return;
    returnFocus = trigger || document.activeElement;
    if (typeof dialog.showModal === "function") dialog.showModal();
    else dialog.setAttribute("open", "");
    body.classList.add("crown-dialog-open");
    const focusTarget = dialog.querySelector("input, summary, button, a[href]");
    focusTarget?.focus();
  };

  const closeDialog = (dialog) => {
    if (!dialog) return;
    if (typeof dialog.close === "function") dialog.close();
    else dialog.removeAttribute("open");
    body.classList.remove("crown-dialog-open");
    returnFocus?.focus();
    returnFocus = null;
  };

  const promo = document.querySelector("[data-crown-promo]");
  document.querySelector("[data-crown-promo-close]")?.addEventListener("click", () => {
    if (promo) promo.hidden = true;
    try { sessionStorage.setItem("crown-promo-dismissed", "1"); } catch {}
  });
  try {
    if (sessionStorage.getItem("crown-promo-dismissed") === "1" && promo) promo.hidden = true;
  } catch {}

  const menu = document.querySelector("[data-crown-menu]");
  const search = document.querySelector("[data-crown-search]");
  document.querySelectorAll("[data-crown-menu-open]").forEach((button) => {
    button.addEventListener("click", () => openDialog(menu, button));
  });
  document.querySelectorAll("[data-crown-search-open]").forEach((button) => {
    button.addEventListener("click", () => {
      if (menu?.open) closeDialog(menu);
      closeMega();
      openDialog(search, button);
    });
  });
  document.querySelectorAll("[data-crown-dialog-close]").forEach((button) => {
    button.addEventListener("click", () => closeDialog(button.closest("dialog")));
  });
  document.querySelectorAll("dialog").forEach((dialog) => {
    dialog.addEventListener("cancel", (event) => {
      event.preventDefault();
      closeDialog(dialog);
    });
    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) closeDialog(dialog);
    });
    dialog.addEventListener("close", () => body.classList.remove("crown-dialog-open"));
  });

  const header = document.querySelector("[data-crown-header]");
  const mega = document.querySelector("[data-crown-mega]");
  const megaTriggers = [...document.querySelectorAll("[data-crown-mega-trigger]")];
  const region = document.querySelector("[data-crown-region]");
  let megaCloseTimer;

  const closeMega = () => {
    if (!mega) return;
    window.clearTimeout(megaCloseTimer);
    mega.hidden = true;
    megaTriggers.forEach((button) => button.setAttribute("aria-expanded", "false"));
    body.classList.remove("crown-mega-open");
  };

  const showMega = (button) => {
    if (!mega || !button) return;
    window.clearTimeout(megaCloseTimer);
    const key = button.dataset.crownMegaTrigger;
    mega.querySelectorAll("[data-crown-mega-panel]").forEach((panel) => {
      panel.hidden = panel.dataset.crownMegaPanel !== key;
    });
    megaTriggers.forEach((candidate) => candidate.setAttribute("aria-expanded", String(candidate === button)));
    mega.hidden = false;
    if (region) region.open = false;
    body.classList.add("crown-mega-open");
  };

  const scheduleMegaClose = () => {
    window.clearTimeout(megaCloseTimer);
    megaCloseTimer = window.setTimeout(closeMega, 140);
  };

  const precisePointer = window.matchMedia("(hover: hover) and (pointer: fine)");
  megaTriggers.forEach((button) => {
    button.addEventListener("click", () => {
      if (!mega) return;
      const alreadyOpen = !mega.hidden && button.getAttribute("aria-expanded") === "true";
      if (alreadyOpen) { closeMega(); return; }
      showMega(button);
      // Triggers that live INSIDE the menu (the mobile drill-down rows and
      // Back) hide themselves by opening another panel. Focus then falls to
      // <body>, the focusout handler below sees activeElement outside the
      // header, and the whole menu closes the instant it was navigated.
      // Parking focus on the panel that just opened keeps focus in the header
      // and doubles as the correct place for a screen reader to continue.
      if (mega.contains(button)) {
        mega.querySelector("[data-crown-mega-panel]:not([hidden])")?.focus();
      }
    });
    button.addEventListener("pointerenter", () => {
      if (precisePointer.matches) showMega(button);
    });
    button.addEventListener("keydown", (event) => {
      if (event.key !== "ArrowDown") return;
      event.preventDefault();
      showMega(button);
      mega?.querySelector("[data-crown-mega-panel]:not([hidden]) a")?.focus();
    });
  });

  header?.addEventListener("pointerenter", () => window.clearTimeout(megaCloseTimer));
  header?.addEventListener("pointerleave", (event) => {
    if (event.pointerType === "mouse") scheduleMegaClose();
  });
  header?.addEventListener("focusout", () => {
    window.requestAnimationFrame(() => {
      if (header && !header.contains(document.activeElement)) closeMega();
    });
  });
  region?.addEventListener("toggle", () => {
    if (region.open) closeMega();
  });

  document.addEventListener("click", (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (mega && !mega.hidden && target && !mega.contains(target) && !target.closest("[data-crown-mega-trigger]")) closeMega();
    if (region?.open && target && !region.contains(target)) region.open = false;
  });
  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    closeMega();
    if (region?.open) region.open = false;
  });

  const updateHeader = () => header?.classList.toggle("is-scrolled", window.scrollY > 8);
  window.addEventListener("scroll", updateHeader, { passive: true });
  updateHeader();

  document.querySelectorAll("[data-crown-hero]").forEach((hero) => {
    const track = hero.querySelector("[data-crown-hero-track]");
    const slides = [...hero.querySelectorAll("[data-crown-hero-slide]")];
    const status = hero.querySelector("[data-crown-hero-status]");
    let index = 0;
    const select = (next) => {
      index = (next + slides.length) % slides.length;
      track.style.transform = `translateX(${-100 * index}%)`;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.setAttribute("aria-hidden", String(!active));
        slide.querySelectorAll("a, button").forEach((control) => { control.tabIndex = active ? 0 : -1; });
      });
      if (status) status.textContent = `Slide ${index + 1} of ${slides.length}`;
    };
    hero.querySelector("[data-crown-hero-prev]")?.addEventListener("click", () => { stop(); select(index - 1); });
    hero.querySelector("[data-crown-hero-next]")?.addEventListener("click", () => { stop(); select(index + 1); });

    // Autoplay: opt in with data-crown-hero-autoplay="<ms>". Driving the
    // carousel by hand latches it off, it pauses while the tab is hidden or
    // the pointer/keyboard is on the hero, and it does not start on its own
    // when the visitor has asked for reduced motion.
    //
    // `stopped` is the visitor's intent and is the only thing the play/pause
    // button reflects. `pause()` is the incidental kind - hover, focus, a
    // hidden tab - and must NOT flip the button, or it would read "play"
    // every time the pointer crossed the hero while still set to autoplay.
    const interval = Number(hero.dataset.crownHeroAutoplay || 0);
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)");
    const toggle = hero.querySelector("[data-crown-hero-toggle]");
    const playIcon = hero.querySelector('[data-crown-hero-icon="play"]');
    const pauseIcon = hero.querySelector('[data-crown-hero-icon="pause"]');
    let timer = null;
    let stopped = false;
    // Pressing play is an explicit, scoped request for motion, so it overrides
    // the reduced-motion default for this carousel only. Nothing starts moving
    // under that setting unless the visitor asks for it here.
    let forced = false;
    const play = () => {
      if (timer || stopped || slides.length < 2 || interval <= 0) return;
      if (reduced.matches && !forced) return;
      timer = setInterval(() => select(index + 1), interval);
    };
    const pause = () => { clearInterval(timer); timer = null; };
    const reflect = () => {
      if (!toggle) return;
      const playing = !stopped;
      toggle.setAttribute("aria-pressed", String(playing));
      toggle.setAttribute("aria-label", playing ? "Pause slideshow" : "Play slideshow");
      // toggleAttribute, NOT `.hidden`. `hidden` is an HTMLElement IDL
      // property; SVGElement does not have it, so `svg.hidden = true` sets a
      // meaningless expando and the icon never changes - silently, with the
      // aria-label flipping correctly the whole time, which is what made this
      // look like it worked. toggleAttribute is on Element, so it reflects.
      if (playIcon) playIcon.toggleAttribute("hidden", playing);
      if (pauseIcon) pauseIcon.toggleAttribute("hidden", !playing);
    };
    function stop() { stopped = true; pause(); reflect(); }
    const resume = () => { stopped = false; forced = true; play(); reflect(); };

    if (interval > 0) {
      // Slides 2+ are lazy so they cost nothing before first paint. Once the
      // page has loaded, promote them: an autoplaying carousel that advances
      // onto an unfetched image shows a black frame.
      const preload = () => slides.forEach((slide) =>
        slide.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = "eager"; }));
      if (document.readyState === "complete") preload();
      else window.addEventListener("load", preload, { once: true });

      hero.addEventListener("mouseenter", pause);
      hero.addEventListener("mouseleave", play);
      hero.addEventListener("focusin", pause);
      hero.addEventListener("focusout", play);
      document.addEventListener("visibilitychange", () => (document.hidden ? pause() : play()));
      reduced.addEventListener?.("change", () => (reduced.matches && !forced ? pause() : play()));
      toggle?.addEventListener("click", () => (stopped ? resume() : stop()));
      play();
      // A carousel that never moves must not offer a pause button, and one
      // held still by the reduced-motion default should read "play".
      if (!timer) stopped = true;
      reflect();
    }

    if (toggle && (interval <= 0 || slides.length < 2)) toggle.remove();

    select(0);
  });

  // Bot trap for the Zoho forms (footer signup, /pages/contact), 2026-11-03.
  // The Zoho keys are left blank in the HTML and copied in here on submit, so a
  // bot replaying the scraped form posts blank keys and Zoho rejects it. A
  // submit is treated as a bot, and sent to the thank-you URL without posting,
  // when the hidden honeypot is filled, when nobody touched the form (no key,
  // pointer, input or paste event), or when it comes under 2 s after load.
  // Registered BEFORE the data-crown-submit block below on purpose, so a
  // blocked submit can stop the busy-button handler.
  const guardLoaded = Date.now();
  document.querySelectorAll("form[data-crown-guard]").forEach((form) => {
    let touched = false;
    ["keydown", "pointerdown", "input", "paste"].forEach((type) => {
      form.addEventListener(type, () => { touched = true; }, { passive: true });
    });
    const decode = (value) => {
      try { return atob(value || ""); } catch (error) { return ""; }
    };
    form.addEventListener("submit", (event) => {
      const trap = form.querySelector("[data-crown-guard-trap]");
      if ((trap && trap.value) || !touched || Date.now() - guardLoaded < 2000) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const thanks = form.querySelector('input[name="returnURL"]');
        if (thanks && thanks.value) window.location.assign(thanks.value);
        return;
      }
      if (trap) trap.disabled = true;
      const key = form.querySelector('input[name="xnQsjsdp"]');
      const id = form.querySelector('input[name="xmIwtLD"]');
      if (key) key.value = decode(form.dataset.crownGuardK);
      if (id) id.value = decode(form.dataset.crownGuardI);
    });
  });

  // Full-page-POST submit buttons: show the click landed and stop a second
  // one. The label swaps to the value of data-crown-submit-busy until the
  // navigation completes (or the browser restores the page from cache).
  document.querySelectorAll("[data-crown-submit]").forEach((button) => {
    const form = button.form;
    if (!form) return;
    const idle = button.innerHTML;
    const restore = () => {
      button.disabled = false;
      button.removeAttribute("aria-busy");
      button.innerHTML = idle;
    };
    form.addEventListener("submit", () => {
      if (!form.checkValidity()) return;
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
      if (button.dataset.crownSubmitBusy) button.textContent = button.dataset.crownSubmitBusy;
    });
    window.addEventListener("pageshow", restore);
  });

  document.querySelectorAll("[data-crown-rail]").forEach((rail) => {
    const track = rail.querySelector("[data-crown-rail-track]");
    const previous = rail.querySelector("[data-crown-rail-prev]");
    const next = rail.querySelector("[data-crown-rail-next]");
    if (!track) return;
    const update = () => {
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      if (previous) previous.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= maximum - 2;
    };
    const move = (direction) => track.scrollBy({ left: direction * track.clientWidth * 0.82, behavior: "smooth" });
    previous?.addEventListener("click", () => move(-1));
    next?.addEventListener("click", () => move(1));
    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update, { passive: true });
    update();
  });

  document.querySelectorAll("[data-crown-tabs]").forEach((tabsRoot) => {
    const tabs = [...tabsRoot.querySelectorAll('[role="tab"]')];
    const select = (tab) => {
      tabs.forEach((candidate) => {
        const selected = candidate === tab;
        candidate.setAttribute("aria-selected", String(selected));
        candidate.tabIndex = selected ? 0 : -1;
        const panel = document.getElementById(candidate.getAttribute("aria-controls"));
        if (panel) panel.hidden = !selected;
      });
    };
    tabs.forEach((tab, tabIndex) => {
      tab.addEventListener("click", () => select(tab));
      tab.addEventListener("keydown", (event) => {
        if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
        event.preventDefault();
        let targetIndex = tabIndex;
        if (event.key === "ArrowLeft") targetIndex = (tabIndex - 1 + tabs.length) % tabs.length;
        if (event.key === "ArrowRight") targetIndex = (tabIndex + 1) % tabs.length;
        if (event.key === "Home") targetIndex = 0;
        if (event.key === "End") targetIndex = tabs.length - 1;
        select(tabs[targetIndex]);
        tabs[targetIndex].focus();
      });
    });
  });

  const searchForm = document.querySelector("[data-crown-search-form]");
  const searchInput = document.querySelector("[data-crown-search-input]");
  const searchResults = document.querySelector("[data-crown-search-results]");
  const searchEmpty = document.querySelector("[data-crown-search-empty]");
  let searchTimer;
  let searchController;
  const formatMoney = (raw) => {
    const value = Number(raw);
    if (!Number.isFinite(value)) return raw || "";
    const currency = window.Shopify?.currency?.active || "USD";
    return new Intl.NumberFormat(document.documentElement.lang || "en-US", { style: "currency", currency }).format(value);
  };
  const renderResults = (products, term) => {
    searchResults.replaceChildren();
    if (!products.length) {
      const message = document.createElement("p");
      message.textContent = `No products found for “${term}”.`;
      searchResults.append(message);
    }
    products.forEach((product) => {
      const link = document.createElement("a");
      link.className = "crown-lulu-search-result";
      link.href = product.url;
      if (product.image) {
        const image = document.createElement("img");
        image.src = product.image;
        image.alt = product.image_alt || "";
        image.loading = "lazy";
        link.append(image);
      }
      const title = document.createElement("strong");
      title.textContent = product.title;
      link.append(title);
      if (product.price !== null && product.price !== undefined) {
        const price = document.createElement("span");
        if (product.tags?.includes("quote-only")) price.textContent = "Contact for price";
        else if (Number(product.price) === 0) price.textContent = "Price on request";
        else price.textContent = formatMoney(product.price);
        link.append(price);
      }
      searchResults.append(link);
    });
    searchResults.hidden = false;
    if (searchEmpty) searchEmpty.hidden = true;
  };
  searchInput?.addEventListener("input", () => {
    window.clearTimeout(searchTimer);
    const term = searchInput.value.trim();
    if (term.length < 2) {
      searchController?.abort();
      if (searchResults) searchResults.hidden = true;
      if (searchEmpty) searchEmpty.hidden = false;
      return;
    }
    searchTimer = window.setTimeout(async () => {
      searchController?.abort();
      searchController = new AbortController();
      const base = searchForm?.dataset.predictiveUrl || "/search/suggest";
      const endpoint = `${base.replace(/\.json$/, "")}.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=show`;
      try {
        const response = await fetch(endpoint, { signal: searchController.signal, headers: { Accept: "application/json" } });
        if (!response.ok) throw new Error(`Predictive search failed: ${response.status}`);
        const payload = await response.json();
        renderResults(payload.resources?.results?.products || [], term);
      } catch (error) {
        if (error.name !== "AbortError" && searchResults) {
          searchResults.hidden = true;
          if (searchEmpty) searchEmpty.hidden = false;
        }
      }
    }, 180);
  });

  document.querySelectorAll("[data-crown-articles]").forEach(async (articlesRoot) => {
    const grid = articlesRoot.querySelector("[data-crown-article-grid]");
    const status = articlesRoot.querySelector("[data-crown-article-status]");
    const endpoint = articlesRoot.dataset.endpoint;
    const fallbackImages = (articlesRoot.dataset.fallbackImages || "").split("|").filter(Boolean);
    if (!grid || !endpoint) return;

    const textFromHtml = (html) => {
      const parsed = new DOMParser().parseFromString(html || "", "text/html");
      return parsed.body.textContent?.replace(/\s+/g, " ").trim() || "";
    };
    const safeRemoteUrl = (value, fallback = "") => {
      try {
        const parsed = new URL(value, window.location.origin);
        return ["http:", "https:"].includes(parsed.protocol) ? parsed.href : fallback;
      } catch {
        return fallback;
      }
    };
    const articleDate = new Intl.DateTimeFormat(document.documentElement.lang || "en-US", {
      month: "long",
      day: "numeric",
      year: "numeric"
    });

    try {
      const response = await fetch(endpoint, { credentials: "omit", headers: { Accept: "application/json" } });
      if (!response.ok) throw new Error(`Article feed failed: ${response.status}`);
      const posts = await response.json();
      if (!Array.isArray(posts) || posts.length === 0) throw new Error("Article feed was empty");

      const fragment = document.createDocumentFragment();
      posts.slice(0, 6).forEach((post, postIndex) => {
        const titleText = textFromHtml(post.title?.rendered) || "Crown Racing update";
        const excerptText = textFromHtml(post.excerpt?.rendered);
        const articleUrl = safeRemoteUrl(post.link, "https://crownconceptsusa.com/category/crown-racing/");
        const fallbackImage = fallbackImages[postIndex % fallbackImages.length] || "";
        const imageUrl = safeRemoteUrl(post.jetpack_featured_media_url, fallbackImage);

        const article = document.createElement("article");
        article.className = "crown-lulu-highlights__article";

        const media = document.createElement("a");
        media.className = "crown-lulu-highlights__media";
        media.href = articleUrl;
        media.tabIndex = -1;
        const image = document.createElement("img");
        image.addEventListener("error", () => {
          if (fallbackImage && image.src !== safeRemoteUrl(fallbackImage)) image.src = fallbackImage;
        }, { once: true });
        image.src = imageUrl;
        image.alt = titleText;
        image.width = 1200;
        image.height = 800;
        image.loading = "lazy";
        image.decoding = "async";
        image.referrerPolicy = "no-referrer";
        media.append(image);

        const copy = document.createElement("div");
        const meta = document.createElement("span");
        meta.className = "crown-lulu-highlights__meta";
        const parsedDate = new Date(post.date);
        meta.textContent = Number.isNaN(parsedDate.getTime()) ? "Crown Racing" : `Crown Racing · ${articleDate.format(parsedDate)}`;
        const heading = document.createElement("h3");
        heading.textContent = titleText;
        const excerpt = document.createElement("p");
        excerpt.textContent = excerptText;
        const link = document.createElement("a");
        link.href = articleUrl;
        link.textContent = "Read article";
        copy.append(meta, heading, excerpt, link);
        article.append(media, copy);
        fragment.append(article);
      });

      grid.replaceChildren(fragment);
      articlesRoot.dataset.articleState = "live";
      if (status) status.textContent = "Latest Crown Racing articles loaded.";
    } catch {
      articlesRoot.dataset.articleState = "fallback";
      if (status) status.textContent = "Current articles could not be loaded. Showing selected Crown highlights.";
    }
  });

  document.querySelectorAll("[data-crown-product-gallery]").forEach((gallery) => {
    const mainImage = gallery.querySelector(".crown-lulu-product-gallery__image");
    gallery.querySelectorAll("[data-crown-product-thumb]").forEach((button) => {
      button.addEventListener("click", () => {
        if (!mainImage) return;
        mainImage.src = button.dataset.src;
        mainImage.srcset = "";
        mainImage.alt = button.dataset.alt || "";
        gallery.querySelectorAll("[data-crown-product-thumb]").forEach((candidate) => candidate.removeAttribute("aria-current"));
        button.setAttribute("aria-current", "true");
      });
    });
  });

  document.querySelectorAll("[data-crown-product-page]").forEach((productPage) => {
    const form = productPage.querySelector(".crown-lulu-product-form");
    const variantSelect = form?.querySelector('select[name="id"]');
    if (!form || !variantSelect) return;
    const price = productPage.querySelector("[data-crown-product-price]");
    const status = productPage.querySelector("[data-crown-product-status]");
    const sku = productPage.querySelector("[data-crown-product-sku]");
    const add = form.querySelector("[data-crown-product-add]");
    const quote = form.querySelector("[data-crown-product-quote]");
    const soldOut = form.querySelector("[data-crown-product-sold-out]");
    const dynamicCheckout = form.querySelector("[data-crown-product-dynamic-checkout]");
    const quoteOnly = productPage.dataset.productQuoteOnly === "true";
    const discontinued = productPage.dataset.productDiscontinued === "true";

    const updateVariant = () => {
      const option = variantSelect.selectedOptions[0];
      const available = option.dataset.available === "true";
      const rawPrice = Number(option.dataset.price || 0);
      const compareAt = Number(option.dataset.compareAt || 0);
      if (price) {
        price.replaceChildren();
        if (rawPrice === 0) price.textContent = "Price on request";
        else {
          if (compareAt > rawPrice) {
            const previous = document.createElement("s");
            previous.textContent = option.dataset.compareAtFormatted;
            price.append(previous);
          }
          const current = document.createElement("span");
          current.textContent = option.dataset.priceFormatted;
          price.append(current);
        }
      }
      const isSoldOut = discontinued && !available;
      const needsQuote = !isSoldOut && (quoteOnly || rawPrice === 0 || !available);
      if (status) {
        if (isSoldOut) status.textContent = "No longer available";
        else if (needsQuote) status.textContent = "We'll confirm price, lead time, and shipping.";
        else status.textContent = "";
        status.hidden = !isSoldOut && !needsQuote;
      }
      if (add) add.hidden = needsQuote || isSoldOut;
      productPage.querySelectorAll("[data-crown-product-qty]").forEach((el) => { el.hidden = needsQuote || isSoldOut; });
      if (quote) {
        quote.hidden = !needsQuote;
        const quoteLink = quote.querySelector("[data-crown-product-quote-link]") || quote;
        const quoteUrl = new URL(quoteLink.href, window.location.origin);
        quoteUrl.searchParams.set("sku", option.dataset.sku || "");
        quoteUrl.searchParams.set("reason", quoteOnly ? "freight" : rawPrice === 0 ? "price" : "stock");
        quoteLink.href = quoteUrl.pathname + quoteUrl.search;
      }
      if (soldOut) soldOut.hidden = !isSoldOut;
      if (dynamicCheckout) dynamicCheckout.hidden = needsQuote || isSoldOut;
    };
    variantSelect.addEventListener("change", updateVariant);
    updateVariant();
  });

  // Inline nav search: icon expands an input in the header bar; predictive
  // results drop below it. Reuses the predictive endpoint + money format.
  document.querySelectorAll("[data-crown-navsearch]").forEach((wrap) => {
    const form = wrap.querySelector("[data-crown-navsearch-form]");
    const input = wrap.querySelector("[data-crown-navsearch-input]");
    const toggle = wrap.querySelector("[data-crown-navsearch-toggle]");
    const results = wrap.querySelector("[data-crown-navsearch-results]");
    if (!form || !input || !toggle) return;
    let timer = null;
    let controller = null;

    const close = () => {
      wrap.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
      input.tabIndex = -1;
      // Let the dropdown animate out before it is removed.
      if (results && !results.hidden) {
        results.classList.add("is-closing");
        window.setTimeout(() => {
          results.hidden = true;
          results.replaceChildren();
          results.classList.remove("is-closing");
        }, 170);
      }
    };
    const open = () => {
      wrap.classList.add("is-open");
      toggle.setAttribute("aria-expanded", "true");
      input.tabIndex = 0;
      window.setTimeout(() => input.focus(), 60);
    };

    toggle.addEventListener("click", () => {
      if (!wrap.classList.contains("is-open")) open();
      else if (input.value.trim()) form.submit();
      else close();
    });
    input.addEventListener("keydown", (event) => {
      if (event.key === "Escape") { input.blur(); close(); }
    });
    document.addEventListener("click", (event) => {
      if (wrap.classList.contains("is-open") && !wrap.contains(event.target)) close();
    });

    input.addEventListener("input", () => {
      const term = input.value.trim();
      window.clearTimeout(timer);
      if (!results) return;
      if (term.length < 2) { results.hidden = true; results.replaceChildren(); return; }
      timer = window.setTimeout(async () => {
        controller?.abort();
        controller = new AbortController();
        const base = form.dataset.predictiveUrl || "/search/suggest";
        const endpoint = `${base.replace(/\.json$/, "")}.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=show`;
        try {
          const response = await fetch(endpoint, { signal: controller.signal, headers: { Accept: "application/json" } });
          if (!response.ok) throw new Error(`Predictive search failed: ${response.status}`);
          const products = (await response.json()).resources?.results?.products || [];
          results.replaceChildren();
          products.forEach((product) => {
            const link = document.createElement("a");
            link.href = product.url;
            const title = document.createElement("strong");
            title.textContent = product.title;
            link.append(title);
            const price = document.createElement("span");
            if (product.tags?.includes("quote-only")) price.textContent = "Contact for price";
            else if (Number(product.price) === 0) price.textContent = "Price on request";
            else price.textContent = formatMoney(product.price);
            link.append(price);
            results.append(link);
          });
          if (!products.length) {
            const none = document.createElement("p");
            none.textContent = "No matches - press Enter for full search.";
            results.append(none);
          }
          results.hidden = false;
        } catch (error) {
          if (error.name !== "AbortError") results.hidden = true;
        }
      }, 200);
    });
  });

  document.querySelectorAll("[data-crown-sort]").forEach((select) => {
    select.addEventListener("change", () => select.form?.requestSubmit());
  });
  // Filters apply on tick - no Apply click needed (the button stays as the
  // no-JS fallback and for the price min/max inputs).
  document.querySelectorAll("[data-crown-filter-form] input[type='checkbox']:not([data-crown-price-bucket])").forEach((box) => {
    box.addEventListener("change", () => box.form?.requestSubmit());
  });
  // Price bounds apply on commit (blur or Enter) as well.
  document.querySelectorAll("[data-crown-filter-form] input[type='number']").forEach((field) => {
    field.addEventListener("change", () => field.form?.requestSubmit());
  });
  // Filter panel behavior: one open at a time, outside click / Esc closes,
  // per-filter Clear unchecks its own panel and reapplies. The open panel
  // survives the reload each selection causes (sessionStorage), so
  // multi-selecting never means reopening the dropdown.
  const OPEN_FILTER_KEY = "crown-open-filter";
  const filterLabel = (panel) => panel.querySelector("summary span")?.textContent.trim() || "";
  document.querySelectorAll("[data-crown-filter-group]").forEach((group) => {
    const panels = group.querySelectorAll("[data-crown-filter]");
    let restoring = true;
    try {
      const wanted = sessionStorage.getItem(OPEN_FILTER_KEY);
      if (wanted) panels.forEach((panel) => { if (filterLabel(panel) === wanted) panel.open = true; });
    } catch (e) { /* storage unavailable */ }
    restoring = false;
    panels.forEach((panel) => {
      panel.addEventListener("toggle", () => {
        if (panel.open) {
          panels.forEach((other) => { if (other !== panel) other.open = false; });
          try { sessionStorage.setItem(OPEN_FILTER_KEY, filterLabel(panel)); } catch (e) { /* noop */ }
        } else {
          try {
            if (sessionStorage.getItem(OPEN_FILTER_KEY) === filterLabel(panel) && !restoring) {
              const stillOpen = [...panels].some((other) => other.open);
              if (!stillOpen) sessionStorage.removeItem(OPEN_FILTER_KEY);
            }
          } catch (e) { /* noop */ }
        }
      });
    });
    const closeAll = () => {
      panels.forEach((panel) => { panel.open = false; });
      try { sessionStorage.removeItem(OPEN_FILTER_KEY); } catch (e) { /* noop */ }
    };
    document.addEventListener("click", (event) => {
      if (!group.contains(event.target)) closeAll();
    });
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closeAll();
    });
  });
  // Cart quantities apply on change (Update button lives in noscript only).
  document.querySelectorAll("[data-crown-cart-qty]").forEach((field) => {
    field.addEventListener("change", () => field.form?.submit());
  });
  // Product page contact menu: outside click / Esc closes.
  document.querySelectorAll("[data-crown-contact-menu]").forEach((menu) => {
    document.addEventListener("click", (event) => {
      if (menu.open && !menu.contains(event.target)) menu.open = false;
    });
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") menu.open = false;
    });
  });
  // Price buckets: single-select; picking one writes the hidden bounds and
  // reapplies.
  document.querySelectorAll("[data-crown-price-bucket]").forEach((bucket) => {
    bucket.addEventListener("change", () => {
      const panel = bucket.closest("[data-crown-filter]");
      panel?.querySelectorAll("[data-crown-price-bucket]").forEach((other) => {
        if (other !== bucket) other.checked = false;
      });
      const form = bucket.closest("form");
      const min = form?.querySelector("[data-crown-price-min]");
      const max = form?.querySelector("[data-crown-price-max]");
      if (min) min.value = bucket.checked ? bucket.dataset.min : "";
      if (max) max.value = bucket.checked ? bucket.dataset.max : "";
      form?.requestSubmit();
    });
  });
  document.querySelectorAll("[data-crown-filter-clear]").forEach((button) => {
    button.addEventListener("click", () => {
      const panel = button.closest("[data-crown-filter]");
      panel.querySelectorAll("input[type='checkbox']").forEach((box) => { box.checked = false; });
      const form = button.closest("form");
      if (panel.querySelector("[data-crown-price-bucket]")) {
        form?.querySelectorAll("[data-crown-price-min], [data-crown-price-max]").forEach((field) => { field.value = ""; });
      }
      form?.requestSubmit();
    });
  });
  // URL hygiene on submit: empty fields and a default-sort echo would
  // pollute the URL (?filter.v.price.gte=&sort_by=...) and needlessly switch
  // the catalog into server mode, losing the global ordering.
  document.querySelectorAll("[data-crown-filter-form]").forEach((form) => {
    form.addEventListener("submit", () => {
      form.querySelectorAll("input, select").forEach((field) => {
        if (field.name && field.value === "") field.disabled = true;
      });
      const sort = form.querySelector("[data-crown-sort]");
      const defaultSort = document.querySelector("[data-crown-catalog]")?.dataset.defaultSort;
      if (sort && defaultSort && sort.value === defaultSort) sort.disabled = true;
    });
  });
  document.querySelectorAll("[data-crown-localization-select]").forEach((select) => {
    select.addEventListener("change", () => select.form?.requestSubmit());
  });
})();
